<template>
  <div>
    <vs-prompt
      title="Select product to add"
      @cancel="val = ''"
      @accept="accept"
      :active.sync="prompt"
      accept-text="Add product"
      :is-valid="validForm"
      class="add-stock-transfer-product-popup"
    >
      <div class="data-list-container data-list-list-view">
        <vs-table
          v-if="filteredProducts"
          ref="table"
          class="mt-8"
          pagination
          search
          maxItems="6"
          v-model="selectedProduct"
          :data="filteredProducts"
          noDataText="No data"
        >
          <template slot="thead">
            <vs-th sort-key="number">Number</vs-th>
            <vs-th sort-key="stockProduct.name">Name</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                <vs-td>
                  <div
                    class="
                      product-name
                      font-medium
                      truncate
                      flex flex-row
                      items-center
                    "
                  >
                    <img width="40" :src="ProductIcon" />
                    <p class="ml-4">{{ tr.stockProductId.id }}</p>
                  </div>
                </vs-td>
                <vs-td :data="tr.name">
                  <div v-if="tr.name">
                    {{ tr.name }}
                  </div>
                  <div v-else>
                    <vs-chip> No name </vs-chip>
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ProductIcon from "@/assets/images/product-icon.png";
export default {
  data() {
    return {
      moment,
      ProductIcon,

      prompt: false,
      selectedProduct: null,

      eligibleProductsInfo: null,
    };
  },
  props: {
    existingProducts: {
      type: Array,
      default: () => [],
    },
    totalVenueStock: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({}),
    validForm() {
      return this.selectedProduct != null;
    },

    // Filter out products already in the form
    filteredProducts() {
      if (!this.totalVenueStock) {
        return [];
      }

      return this.totalVenueStock.filter((e) => {
        return !this.existingProducts.some((p) => p === e.stockProductId.id);
      });
    },
  },
  methods: {
    async show() {
      // dispatch eligible products
      this.prompt = true;
    },
    async accept() {
      this.$emit("productSelected", this.selectedProduct.stockProductId.id);
    },
  },
};
</script>

<style lang="scss">
.add-stock-transfer-product-popup {
  z-index: 52011;

  .vs-dialog {
    max-width: 900px;

    .vs-dialog-text {
      background-color: #f8f8f8;
    }

    .header-table.vs-table--header {
      margin-left: 0 !important;
    }
  }
}
</style>
